'use client';

export { useAnalyticsService } from './useAnalyticsService';
export { useAnalyticsPageVisit } from './useAnalyticsPageVisit';
export { useAnalyticsEvent } from './useAnalyticsEvent';
export { useMetaUserData } from './useMetaUserData';
export type { AnalyticsPlatformContext } from './useAnalyticsEvent';
export {
  mapAttributionParamsToAnalyticsContext,
  parseAnalyticsAttributionFromUrl,
  resolvePersistedAnalyticsAttribution,
} from './analyticsAttribution';
export type {
  AnalyticsAttributionContext,
  AnalyticsAttributionParamKey,
  AnalyticsAttributionParams,
} from './analyticsAttribution';
export { subscribeToAnalyticsDebug, publishAnalyticsDebugEvent } from './analyticsDebugBus';
export type { AnalyticsDebugEvent } from './analyticsDebugBus';
export {
  trackSkinAnalysisStep,
  trackSkinAnalysisSurveyQuestion,
  trackSkinAnalysisSurveySubmit,
  trackSkinAnalysisCapturePose,
  trackSkinAnalysisResumePrompt,
  trackSkinAnalysisPipeline,
  trackSkinAnalysisReportTrait,
  trackSkinAnalysisReportPhoto,
  trackSkinAnalysisRoutineSection,
  trackSkinAnalysisRoutineInteraction,
  trackSkinAnalysisRoutineBag,
  trackSkinAnalysisDiary,
  trackSkinAnalysisScanPreparation,
  trackSkinAnalysisCapturePermission,
  trackSkinAnalysisLocation,
  trackSkinAnalysisReportCta,
} from './skinAnalysisFunnelEvents';
export type {
  FunnelRunParams,
  SkinAnalysisStep,
  SkinAnalysisSurveyPhase,
  SkinAnalysisStepAction,
  SkinAnalysisStepExitVia,
  SkinAnalysisStepParams,
  SkinAnalysisScanPreparationAction,
  SkinAnalysisScanPreparationParams,
  SkinAnalysisCapturePermissionAction,
  SkinAnalysisCapturePermissionParams,
  SkinAnalysisLocationAction,
  SkinAnalysisLocationParams,
  SkinAnalysisReportCtaAction,
  SkinAnalysisReportCtaFailure,
  SkinAnalysisReportCtaParams,
  SkinAnalysisRoutineSheetSection,
  SkinAnalysisDiaryRetestState,
  SkinAnalysisSurveyQuestionAction,
  SkinAnalysisSurveyQuestionParams,
  SkinAnalysisSurveySubmitAction,
  SkinAnalysisSurveySubmitParams,
  SkinAnalysisCapturePoseAction,
  SkinAnalysisCapturePoseParams,
  SkinAnalysisResumePromptAction,
  SkinAnalysisResumePromptParams,
  SkinAnalysisPipelineAction,
  SkinAnalysisPipelineFailedPhase,
  SkinAnalysisPipelineParams,
  SkinAnalysisReportTraitAction,
  SkinAnalysisReportTraitParams,
  SkinAnalysisReportPhotoAction,
  SkinAnalysisReportPhotoParams,
  SkinAnalysisRoutineSection,
  SkinAnalysisRoutineSectionAction,
  SkinAnalysisRoutineSectionParams,
  SkinAnalysisRoutineInteractionAction,
  SkinAnalysisRoutineInteractionParams,
  SkinAnalysisRoutineBagAction,
  SkinAnalysisRoutineBagParams,
  SkinAnalysisDiaryAction,
  SkinAnalysisDiaryParams,
} from './skinAnalysisFunnelEvents';
export { trackPdpInteraction } from './pdpInteraction';
export type { PdpInteractionAction } from './pdpInteraction';
export {
  trackBannerClicked,
  trackNavigationClicked,
  trackWishlistClicked,
  trackContactLinkClicked,
  trackReviewInteraction,
  trackFilterApplied,
  trackViewCart,
  trackSearchResultsViewed,
  trackViewItemList,
  trackProgressBarInteraction,
  trackAppHandoffInteraction,
  trackEngagementThresholdReached,
} from './frontInteractionEvents';
export type {
  BannerClickedParams,
  NavigationItem,
  NavigationClickedParams,
  WishlistAction,
  ContactType,
  ReviewAction,
  FilterType,
  FilterAppliedParams,
  ViewCartParams,
  SearchResultsViewedParams,
  ViewItemListParams,
  ProgressBarAction,
  ProgressBarParams,
  AppHandoffAction,
  AppHandoffParams,
  EngagementThresholdParams,
} from './frontInteractionEvents';
export {
  reviewEventBaseParams,
  trackReviewSectionViewed,
  trackReviewTabClicked,
  trackReviewSectionDwell,
  trackReviewFilterUsed,
  trackReviewCardExpanded,
  trackReviewImageSwiped,
  trackLoadMoreReviews,
  trackAiSummaryViewed,
  trackAiSummaryRead,
  trackAiInsightCardSwiped,
  trackAiSummaryHelpfulVote,
} from './reviewSectionEvents';
export type {
  ReviewBlock,
  ReviewEventBase,
  ReviewSectionEntry,
  ReviewFilterType,
  AiSummaryReadSignal,
  AiInsightGroup,
  AiSummaryVote,
} from './reviewSectionEvents';
